var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 14.1016H10.35C7.11913 14.1016 4.5 16.7207 4.5 19.9516C4.5 21.0285 5.37304 21.9016 6.45 21.9016H10.5M15.9 6.00156C15.9 8.15547 14.1539 9.90156 12 9.90156C9.84609 9.90156 8.1 8.15547 8.1 6.00156C8.1 3.84765 9.84609 2.10156 12 2.10156C14.1539 2.10156 15.9 3.84765 15.9 6.00156ZM17.8125 23.1016H15.3V20.5891L20.0672 15.8219C20.761 15.1281 21.8858 15.1281 22.5796 15.8219C23.2735 16.5157 23.2735 17.6406 22.5796 18.3344L17.8125 23.1016Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEditBlue);
export default __webpack_public_path__ + "static/media/user-edit-blue.da4020596a07a1d461569ffa7a231d95.svg";
export { ForwardRef as ReactComponent };